import { useNotificationStore } from '@/stores'
import type { Notification, NotificationType } from '@/stores/notification'

type NotificationWithTimeout = Omit<Notification, 'id'> & { timeout?: number }

const DEFAULT_TIMEOUT = 5000

function showNotification(
  message: string,
  type: NotificationType,
  timeout?: number,
  closeable?: boolean,
  actions?: Array<{ title: string; handler: () => void }>,
): Notification
function showNotification(notification: NotificationWithTimeout): Notification
function showNotification(
  messageOrNotification: string | NotificationWithTimeout,
  type?: NotificationType,
  timeout?: number,
  closeable?: boolean,
  actions?: Array<{ title: string; handler: () => void }>,
): Notification {
  const notificationStore = useNotificationStore()

  let payload: Notification
  let notificationTimeout: number | undefined

  if (typeof messageOrNotification === 'string') {
    payload = {
      type: type as NotificationType,
      message: messageOrNotification,
      closeable: closeable,
      actions: actions,
    }
    notificationTimeout = timeout
  } else {
    payload = {
      type: messageOrNotification.type,
      message: messageOrNotification.message,
      headline: messageOrNotification.headline,
      closeable: messageOrNotification.closeable,
      actions: messageOrNotification.actions,
    }
    notificationTimeout = messageOrNotification.timeout
  }

  const notification = notificationStore.addNotification(payload)
  window.setTimeout(() => notificationStore.removeNotification(notification.id), notificationTimeout || DEFAULT_TIMEOUT)

  return notification
}
export { showNotification }
